export const PICK_AND_DROP = {
    LANDING_PAGE: '/pick-and-drop',
    NEARBY_SERVICE_CENTRES: '/pick-and-drop-near-me',
    NOTIFY_ME: '/notify-me',
};

export const NO_INDEX_ROUTES = [
    PICK_AND_DROP.LANDING_PAGE,
    PICK_AND_DROP.NEARBY_SERVICE_CENTRES,
    PICK_AND_DROP.NOTIFY_ME,
];

export const NEW_ROUTEMAP = {
    REPEAT_BOOKING: '/repeat-booking',
    SERVICE_REMINDER: '/service-reminder',
    SERVICE_REMINDER_UPDATED: '/service-reminder/updated',
    REWARDS: '/rewards',
    VIDEO_OFFER_CLAIMED: '/video-offer/offer-claimed',
    PUD_TRACKER: '/pick-drop-tracker',
};
